import { render, staticRenderFns } from "./CartDiscounts.vue?vue&type=template&id=338c626a&scoped=true&"
import script from "./CartDiscounts.vue?vue&type=script&lang=ts&"
export * from "./CartDiscounts.vue?vue&type=script&lang=ts&"
import style0 from "./CartDiscounts.vue?vue&type=style&index=0&id=338c626a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338c626a",
  null
  
)

export default component.exports